import { Typography } from "@packages/ds";
import styled from "styled-components";

export const ProcessListRoot = styled.div`
  padding: 16px;
  background-color: var(--dark);
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 16px;
`;

export const ProcessListContainer = styled.div<{
  fullScreen: boolean;
}>`
  overflow: auto;
  ${({ fullScreen }) =>
    fullScreen ? "height: max(calc(100vh - 168px));" : ""};
`;

export const ErrorText = styled(Typography.BodyText)`
  color: var(--snow);
  padding: 24px 16px 16px 24px;
`;
